import { h, Component } from 'preact';
import { Router, route } from 'preact-router';
import Header from './header';
import Home from '../routes/home';
import Merch from '../routes/merch';
import Item from '../routes/merch-item';
import Info from '../routes/info';
import SongPage from '../routes/song-page/'


import ShopifyBuy from 'shopify-buy'
import Helmet from "preact-helmet";


// import Home from 'async!./home';
// import Profile from 'async!./profile';
import ReactGA from 'react-ga';

export const shopClient = ShopifyBuy.buildClient({
	accessToken: 'd6fe3efb8e6d1a746f1d8c2345cadcc3',
	domain: 'kidsuper.myshopify.com',
	appId: '6'
});
	


import sanityClient from '@sanity/client'

const client = sanityClient({
	projectId: 'iytnt0ik',
	dataset: 'production',
	useCdn: false,
})

export default class App extends Component {
	state = {
		currentUrl: window.location.href,
		classUrl: window.location.pathname
	}

	goToMerch = () => route('/', true);
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		this.setState({currentUrl: e.url});

		ReactGA.pageview(e.url);
	};

	render() {
		return (
			<div id="app" class={this.state.currentUrl.slice(1)}>
			
			
			  <Helmet
              htmlAttributes={{lang: "en", amp: undefined}} // amp takes no value
			  title="Home"
			  
               titleTemplate=" %s" />
				<Header url={this.state.currentUrl} goToMerch={this.goToMerch} />
		<div class="innerContent">
		<Router onChange={this.handleRoute}>
					<Home exact path="/"  />
					
					
			
					<Merch  path="/days" />
					<Item  path="/:handle" />

			
					<Info  path="/info" sanity={client} />
					<SongPage path="/:slug" sanity={client} />

				
				
				</Router>
<br />
<br />
<br />
		</div>	
			

			</div>
		);
	}
}
